// extracted by mini-css-extract-plugin
export default {"element":"style_element__gZolH","vertical":"style_vertical__KVvz6","render":"style_render__r0VyZ"};